import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgManualEndProctoring = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.3417 19.2863C17.2698 17.7868 17.8588 16.3148 17.8588 14.0863C17.8588 9.62913 13.456 8.50796 10.2733 8.18419V3.31484C10.2733 1.8789 9.0846 0.714844 7.61833 0.714844C6.15204 0.714844 4.96338 1.8789 4.96338 3.31484V11.1148L4.12844 11.5821C1.87474 12.8433 1.4625 15.8578 3.29794 17.6553L4.96338 19.2863",
		stroke: "currentColor",
		strokeWidth: 1.42857,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgManualEndProctoring;
